import { EncField, Encoding } from '@mode-vegas/vegas';

export function lookupYField(encoding: Encoding, alias: string): EncField | undefined {
  const yField = encoding.y.find((field) => field.id === alias);
  return yField || encoding.y2.find((field) => field.id === alias);
}

export function lookupXField(encoding: Encoding, alias: string): EncField | undefined {
  const xField = encoding.x.find((field) => field.id === alias);
  return xField || encoding.x2.find((field) => field.id === alias);
}
